// extracted by mini-css-extract-plugin
module.exports = {"modalWrap":"list_modalWrap__vGuvh","modalButtons":"list_modalButtons__1YBln","modalButton":"list_modalButton__QIZS4"};